import { Inject } from '@odinjs/odin';

import { APPLICATION_ROUTES, Endpoint, Route, ToastServiceStipulator } from '@philips-emr/hpms-stipulator-commons';
import { PanelAPI } from '@philips-emr/tws-components';
import { ModalButtonType } from '@philips-emr/tws-constants';
import Controller, { OnClick, OnMount } from '@philips-emr/tws-core/lib/client';
import { HttpService, MessageService, ModalService } from '@philips-emr/tws-core/lib/services';
import HistoryService from '@philips-emr/tws-core/lib/services/history-service';
import { ModalButton, ModalProps } from '@philips-emr/tws-core/lib/services/modal-service';

import { CartaoConfirmarAliases as Aliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

@Controller({ fragment: FragmentNames.CARTAO_CONFIRMAR, component: Aliases.LAYOUT_CARTAO_CONFIRMAR })
class CartaoConfirmarController extends BaseController {

  @Inject(Aliases.PANEL_LOADER)
  panelLoader: PanelAPI;
  @Inject(Aliases.PANEL_BUTTON)
  panelButton: PanelAPI;
  @Inject(Aliases.PANEL_MODAL)
  modal: PanelAPI;

  @OnMount(Aliases.LAYOUT_CARTAO_CONFIRMAR)
  onMount(): void {
    this.checkStatus();
    this.modal.setVisible(false);

  }

  @OnClick(Aliases.BUTTON_CONFIRMAR)
  onConfirmarClick(): void {
    ModalService.openDialog(this.newModalDefaultContent());
    this.panelButton.setVisible(false);
    this.panelLoader.setVisible(true);
  }

  checkStatus(): void {
    const { nrSeqBeneficiario, nrSeqContrato } = this.historyService.getCurrentRouteParams();

    void HttpService.get(Endpoint.GET.CARTAO_STATUS, { nrSeqBeneficiario, nrSeqContrato })
      .then(response => {
        const status = response.body;

        switch (status) {
          case 'A':
            HistoryService.push(Route.CARTAO_CONSULTAR, { nrSeqBeneficiario });
            break;
          case 'N':
            HistoryService.push(Route.CARTAO_SOLICITAR, { nrSeqBeneficiario });
            break;
        }

      });
  }

  newModalDefaultContent(): ModalProps {
    const modalDefaultContent: ModalProps = {
      closeable: false,
      dockButtons: this.newDockButtons(),
      title: MessageService.translate('stipulator.confirma-recebimento-segunda-via'),
    };

    return modalDefaultContent;
  }

  newDockButtons(): ModalButton[] {

    const onOk = (): void => {
      const { nrSeqBeneficiario, nrSeqContrato } = this.historyService.getCurrentRouteParams();

      HttpService.post(Endpoint.POST.CARTAO_CONFIRMAR, { nrSeqBeneficiario, nrSeqContrato })
        .then(response => {
          const mensagem = MessageService.translate('stipulator.aviso-solicitacao-realizada').concat(response.body as string);
          ToastServiceStipulator.success(mensagem);
          this.historyService.push(APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO);
        })
        .catch(response => {
          const mensagem = response.body as string;
          ToastServiceStipulator.warning(mensagem);
          this.panelButton.setVisible(true);
          this.panelLoader.setVisible(false);
        });
    };

    const onCancel = (): void => {
      this.panelButton.setVisible(true);
      this.panelLoader.setVisible(false);
    };

    const dockButtons: ModalButton[] = [
      {
        action: onCancel,
        title: MessageService.translate('stipulator.cancelar'),
        type: ModalButtonType.CANCEL,
      },
      {
        action: onOk,
        title: MessageService.translate('stipulator.confirmar'),
        type: ModalButtonType.SUCCESS,
      },
    ];

    return dockButtons;
  }
}

export default CartaoConfirmarController;
